module.exports = __webpack_public_path__ + "static/img/picture.cd717cf6.svg";